import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEocTabA as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEocTabA = (props: {
  data: AprResponseModel | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const newParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("newParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.newParticipants} {formatPercentTotal(props.data?.newParticipants, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const continuingParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("continuingParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.continuingParticipants}{" "}
        {formatPercentTotal(props.data?.continuingParticipants, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const priorYearEnrolledField = () => {
    const propertyName = pn<AprResponseModel>("priorYearEnrolled");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.priorYearEnrolled}{" "}
        {formatPercentTotal(props.data?.priorYearEnrolled, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const priorYearNoLongerEnrolledField = () => {
    const propertyName = pn<AprResponseModel>("priorYearNoLongerEnrolled");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.priorYearNoLongerEnrolled}{" "}
        {formatPercentTotal(props.data?.priorYearNoLongerEnrolled, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const newSummerParticipantEarnedCreditsField = () => {
    const propertyName = pn<AprResponseModel>("newSummerParticipantEarnedCredits");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.newSummerParticipantEarnedCredits}{" "}
        {formatPercentTotal(props.data?.newSummerParticipantEarnedCredits, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const newSummerParticipantNoCreditsField = () => {
    const propertyName = pn<AprResponseModel>("newSummerParticipantNoCredits");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.newSummerParticipantNoCredits}{" "}
        {formatPercentTotal(props.data?.newSummerParticipantNoCredits, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const unknownParticipantsdField = () => {
    const propertyName = pn<AprResponseModel>("unknownParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.unknownParticipants}{" "}
        {formatPercentTotal(props.data?.unknownParticipants, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>;
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Types of Participants Assisted</Typography>
        <Grid container spacing="lg">
          <Grid item xs={6}>
            <Grid container spacing="lg">
              {props.data?.newParticipants != null && (
                <Grid item xs={12}>
                  {newParticipantsField()}
                </Grid>
              )}
              <GridBreak />

              {props.data?.continuingParticipants != null && (
                <Grid item xs={12}>
                  {continuingParticipantsField()}
                </Grid>
              )}

              {props.data?.priorYearEnrolled != null && (
                <Grid item xs={12}>
                  {priorYearEnrolledField()}
                </Grid>
              )}

              {props.data?.priorYearNoLongerEnrolled != null && (
                <Grid item xs={12}>
                  {priorYearNoLongerEnrolledField()}
                </Grid>
              )}

              {props.data?.newSummerParticipantEarnedCredits != null && (
                <Grid item xs={12}>
                  {newSummerParticipantEarnedCreditsField()}
                </Grid>
              )}

              {props.data?.newSummerParticipantNoCredits != null && (
                <Grid item xs={12}>
                  {newSummerParticipantNoCreditsField()}
                </Grid>
              )}

              {props.data?.unknownParticipants != null && (
                <Grid item xs={12}>
                  {unknownParticipantsdField()}
                </Grid>
              )}

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          <Grid item xs={6}>
            <PieChart
              id="pie-tab-a"
              dataSource={props.data?.chartValues}
              palette="Bright"
              title="Participants"
              width="100%"
            >
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
